<template>
	<li class="small-content-card">
		<SmallContentLink :content="content" />
	</li>
</template>

<script>
import { HasContentMixin } from '@/mixins'
import SmallContentLink from '@/components/small/SmallContentLink.vue'

export default {
	name: 'SmallContentCard',
	mixins: [HasContentMixin],
	components: { SmallContentLink },
	computed: {
		isExternal() {
			if(!this.content.link) return 

			return new URL(this.content.link).origin !== window.location.origin ?'_blank' : null
		}
	}
}
</script>